import React from "react";
import "assets/demo/iconosFlotantes.css";
import GenesysMessenger from "components/GenesysMessenger/GenesysMessenger.js";

// reactstrap components

// core components
function Whatsapp() {

  return (
    <>
      <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/font-awesome/4.5.0/css/font-awesome.min.css"/>
      <div className="floating-contact-stack">
        <a href="https://wa.me/573185009110" className="float">
          <i className="fa fa-whatsapp my-float"></i>
        </a>
        <GenesysMessenger />
      </div>
    </>
  );
}

export default Whatsapp;
